// extracted by mini-css-extract-plugin
export default {"profile-plans-wrap":"ProfilePlans_profile-plans-wrap__CnxCX","header":"ProfilePlans_header__R0E+J","body":"ProfilePlans_body__m1GSX"};